import { render, staticRenderFns } from "./EMelderComponentMeldenBs12OptischeTrennlinie.vue?vue&type=template&id=5c86594c"
import script from "./EMelderComponentMeldenBs12OptischeTrennlinie.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs12OptischeTrennlinie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports